import React from 'react';
import ConfirmModal from '../Elements/UI/ConfirmModal';

const Conformationmodal = ({ show, onClose, onConfirm }) => {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Delete post?"
      message="This post will be removed for everyone. This can't be undone."
    />
  );
};

export default Conformationmodal;
